module.exports = __webpack_public_path__ + "media/images/koala-vet-logo-prefix-d588a1ead28791f6ef5b488aef9db78e.svg";